import { inject } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { AuthService } from "../../services/auth.service";

import { environment } from "../../../environments/environment";
import { getUserRoleFromToken } from "./auth-role.helper";

export const AuthGuardFxn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const isAuthenticated = authService.isAuthenticated();
  const url = state.url;

  const token = localStorage.getItem(environment.storageKey);
  const role = getUserRoleFromToken(token);

  // ❌ NOT LOGGED IN → redirect to login
  if (!isAuthenticated && !url.startsWith("/auth")) {
    return router.createUrlTree(["/auth/login"]);
  }

  // ❌ LOGGED IN but accessing auth pages
  if (isAuthenticated && url.startsWith("/auth")) {
    return router.createUrlTree(["/dashboard"]);
  }

  // ❌ ROOT → redirect to dashboard
  if (isAuthenticated && (url === "/" || url === "")) {
    return router.createUrlTree(["/dashboard"]);
  }

  return true;
};